"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var rxjs_1 = require("rxjs"),
    DeviceUtils_1 = require("../classes/DeviceUtils"),
    CodeType_1 = require("../model/CodeType"),
    Point_1 = require("../model/Point"),
    ProgressResponse_1 = require("../model/ProgressResponse"),
    SwipeDirection_1 = require("../model/SwipeDirection"),
    SwipingGesture_1 = require("../model/SwipingGesture"),
    Progress = function () {
  function e(e) {
    this.sdk = e, this.subject = new rxjs_1.Subject(), this.lastProgress = 0, this.expectedTouchRadius = 0, this.Config = {
      AxelZipShortDistanceThreshold: 200,
      displacementDistanceThreshold: 400,
      firstScratchRoundMinDistance: 100,
      minTouchesAllowed: 2,
      progressDistanceMultiplier: 1.1,
      scratchRoundMinDistance: 350,
      tickDistanceThreshold: 200
    }, this.usePointingFingerhintSent = !1, this.paused = !1, this.devicePixelRatio = 1, this.AxelZipShortCodeHeight = 31.4, this.MM_PER_INCH = 25.4;
  }

  return e.prototype.init = function (e) {
    this.devicePixelRatio = e.devicePixelRatio;
    var i = e.ppi;
    i && this.devicePixelRatio && (this.Config.AxelZipShortDistanceThreshold = i * this.AxelZipShortCodeHeight / (this.MM_PER_INCH * this.devicePixelRatio)), this.expectedTouchRadius = e.expectedTouchRadius ? e.expectedTouchRadius : this.expectedTouchRadius;
  }, e.prototype.evaluateTouchData = function (e, i, t, s) {
    if (!(this.paused || e.size < this.Config.minTouchesAllowed)) if (void 0 !== s || void 0 === t && !i.length) {
      if (void 0 !== s) switch (s) {
        case SwipingGesture_1.SwipingGesture.singleSwipe:
          this.computePackOrDisplacementProgress(e);
          break;

        case SwipingGesture_1.SwipingGesture.scratch:
          this.computeDisplacementScratchProgress(e);
          break;

        case SwipingGesture_1.SwipingGesture.tick:
          this.computeTickProgress(e);
      }
    } else switch (void 0 !== t ? t : i[0]) {
      case CodeType_1.CodeType.DisplacementZipShort:
      case CodeType_1.CodeType.DisplacementZip:
      case CodeType_1.CodeType.Displacement:
      case CodeType_1.CodeType.Pack:
      case CodeType_1.CodeType.Axel:
      case CodeType_1.CodeType.AxelZip:
        this.computePackOrDisplacementProgress(e);
        break;

      case CodeType_1.CodeType.Tornado:
        this.computeTornadoProgress(e);
        break;

      case CodeType_1.CodeType.Tick:
        this.computeTickProgress(e);
        break;

      case CodeType_1.CodeType.AxelZipShort:
        this.computeAxelZipShortProgress(e);
        break;

      case CodeType_1.CodeType.DisplacementKey:
        this.computeDisplacementKeyProgress(e);
    }
  }, e.prototype.pause = function () {
    this.paused = !0;
  }, e.prototype.resume = function () {
    this.paused = !1;
  }, e.prototype.reset = function () {
    this.usePointingFingerhintSent = !1, this.lastProgress = 0;
  }, e.prototype.notify = function (e, i, t, s) {
    this.lastProgress = e;
    var o = new ProgressResponse_1.ProgressResponse(e, i, t, s);
    this.subject.next(o);
  }, e.prototype.computePackOrDisplacementProgress = function (e) {
    var o,
        r = 0,
        n = SwipeDirection_1.SwipeDirection.up;
    e.forEach(function (e) {
      var i = e[0],
          t = e[e.length - 1];

      if ("end" !== t.event) {
        var s = Math.abs(t.y - i.y);
        r < s && (r = s, n = i.y > t.y ? SwipeDirection_1.SwipeDirection.up : SwipeDirection_1.SwipeDirection.down, o = i.radius);
      }
    });
    var i = this.Config.displacementDistanceThreshold * this.Config.progressDistanceMultiplier / DeviceUtils_1.default.pageZoomFactor();
    "native" === this.sdk.getAppType() && "pixels" === this.sdk.getCoordinatesUnit() && (i *= this.devicePixelRatio * this.sdk.getScreenResolutionScaleFactor());
    var t = r / i * 100;
    !this.usePointingFingerhintSent && this.expectedTouchRadius && 10 < t && o && o > this.expectedTouchRadius && (this.sdk.getUsability().fingerTooThick(), this.usePointingFingerhintSent = !0), this.notify(Math.min(t, 100), n);
  }, e.prototype.computeAxelZipShortProgress = function (e) {
    var o,
        r = 0,
        n = SwipeDirection_1.SwipeDirection.up;
    e.forEach(function (e) {
      var i = e[0],
          t = e[e.length - 1],
          s = Math.abs(t.y - i.y);
      r < s && (r = s, n = i.y > t.y ? SwipeDirection_1.SwipeDirection.up : SwipeDirection_1.SwipeDirection.down, o = t);
    });
    var i = this.Config.AxelZipShortDistanceThreshold * this.Config.progressDistanceMultiplier / DeviceUtils_1.default.pageZoomFactor();
    "native" === this.sdk.getAppType() && "pixels" === this.sdk.getCoordinatesUnit() && (i *= this.devicePixelRatio * this.sdk.getScreenResolutionScaleFactor());
    var t = r / i * 100;
    o ? this.notify(Math.min(t, 100), n, 1, new Point_1.Point(o.x, o.y)) : this.notify(Math.min(t, 100), n);
  }, e.prototype.computeTickProgress = function (e) {
    var o = 0;
    e.forEach(function (e) {
      var i = e[0],
          t = e[e.length - 1];

      if ("end" !== t.event) {
        var s = Math.abs(t.x - i.x);
        o = Math.max(o, s);
      }
    });
    var i = this.Config.tickDistanceThreshold * this.Config.progressDistanceMultiplier / DeviceUtils_1.default.pageZoomFactor(),
        t = o / i * 100;
    this.notify(Math.min(t, 100));
  }, e.prototype.computeDisplacementScratchProgress = function (e) {
    var s = 0,
        o = [],
        i = 1;

    if (e.forEach(function (e) {
      for (var i = 0, t = 1; t < e.length; t++) {
        i += Math.abs(e[t].y - e[t - 1].y);
      }

      s < i && (s = i, o = e);
    }), o.length) {
      for (var t = 0, r = o[0], n = 1; n < o.length; n++) {
        if (t += Math.abs(o[n].y - o[n - 1].y), 1 < n && (t > this.Config.scratchRoundMinDistance || t > this.Config.firstScratchRoundMinDistance && 1 === i)) !(0 < o[n].y - o[n - 1].y) !== !(0 < o[n - 1].y - o[n - 2].y) && (i++, t = 0, r = o[n - 1]);
      }

      var c = r.y - o[o.length - 1].y;
      s = Math.abs(c);
      var a = 0 < c ? SwipeDirection_1.SwipeDirection.up : SwipeDirection_1.SwipeDirection.down,
          p = this.Config.displacementDistanceThreshold * this.Config.progressDistanceMultiplier / DeviceUtils_1.default.pageZoomFactor(),
          h = s / p * 100;
      this.notify(Math.min(h, 100), a, i);
    }
  }, e.prototype.computeTornadoProgress = function (e) {
    var s = Number.MAX_VALUE,
        o = 0;
    e.forEach(function (e) {
      var i = e[0],
          t = e[e.length - 1];
      i.y < s ? s = i.y : i.y > o && (o = i.y), t.y < s ? s = t.y : t.y > o && (o = t.y);
    });
    var i = (o - s) / (this.Config.displacementDistanceThreshold * this.Config.progressDistanceMultiplier / DeviceUtils_1.default.pageZoomFactor()) * 100;
    this.notify(Math.min(i, 100));
  }, e.prototype.computeDisplacementKeyProgress = function (e) {
    var o,
        r = 0;

    if (e.forEach(function (e, i) {
      for (var t = 0, s = 1; s < e.length; s++) {
        t += Math.abs(e[s].y - e[s - 1].y);
      }

      r < t && (r = t, e, o = i);
    }), o) {
      var i = this.sdk.getDetection().prismaKeyDetection;
      if (!i) return;
      var t = i.prismaKeyDetectedPin.get(o);

      if (t) {
        var s = 20 * t.length;
        this.notify(s);
      }
    }
  }, e;
}();

exports.Progress = Progress;